document.addEventListener("DOMContentLoaded", function() {
    const wordLimit = 28; // Number of words to display before truncating
    const readMoreText = "Read More";
    const readLessText = "Read Less";

    function truncateDescription(descriptionElement) {
        const fullText = descriptionElement.innerHTML.trim();
        const words = fullText.split(' ');
        if (words.length > wordLimit) {
            const truncatedText = words.slice(0, wordLimit).join(' ') + '... ';
            descriptionElement.innerHTML = truncatedText;

            const readMoreLink = document.createElement("a");
            readMoreLink.innerHTML = readMoreText;
            readMoreLink.href = "javascript:void(0)";
            readMoreLink.classList.add("read-more-link");

            readMoreLink.addEventListener("click", function() {
                if (descriptionElement.innerHTML.includes(fullText)) {
                    descriptionElement.innerHTML = truncatedText;
                    readMoreLink.innerHTML = readMoreText;
                } else {
                    descriptionElement.innerHTML = fullText;
                    readMoreLink.innerHTML = readLessText;
                }
                descriptionElement.appendChild(readMoreLink); // Append link again
            });

            descriptionElement.appendChild(readMoreLink);
        }
        descriptionElement.style.display = 'block'; // Make the description visible
    }

    const descriptions = document.querySelectorAll(".collection-description"); // Adjust the selector as needed
    descriptions.forEach(descriptionElement => {
        truncateDescription(descriptionElement);
    });
});
